import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { Button } from "@avenue-8/sidekick-ui";

export const Section = styled.section`
  width: 100%;
  padding: 5rem 0;
  background-color: ${(p) => p.theme.colors.background};

  ${(p) => p.theme.media.mobileDown} {
    padding: 2.5rem 1.5rem;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;

  ${(p) => p.theme.media.laptopDown} {
    grid-template-columns: 1fr;
    gap: 2.5rem;
  }
`;

export const TextColumn = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 8rem 0 3rem;

  ${(p) => p.theme.media.desktopDown} {
    padding: 0 6rem 0 2rem;
  }

  ${(p) => p.theme.media.laptopDown} {
    justify-content: flex-start;
    padding: 0 2rem;
  }

  ${(p) => p.theme.media.mobileDown} {
    padding: 0;
  }
`;

export const TextColumnInner = styled.div`
  width: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const Eyebrow = styled(Typography)`
  color: ${(p) => p.theme.text.colors.brand};
  font-weight: 700;
`;

export const Headline = styled(Typography)`
  margin-bottom: 1rem;

  ${(p) => p.theme.media.mobileDown} {
    font-size: 1.75rem;
    line-height: 1.15;
  }
`;

export const Subheadline = styled(Typography)`
  max-width: 480px;
  margin-bottom: 1.5rem;
`;

export const CtaButton = styled(Button)`
  margin-bottom: 2rem;
`;

export const CardsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  width: 100%;

  ${(p) => p.theme.media.mobileDown} {
    grid-template-columns: 1fr;
  }
`;

export const CardWrap = styled.div`
  display: flex;
`;

export const VisualColumn = styled.div`
  position: relative;
  padding: 0 3rem 0 8rem;

  ${(p) => p.theme.media.desktopDown} {
    padding: 0 3rem 0 6rem;
  }

  ${(p) => p.theme.media.laptopDown} {
    padding: 0 2rem;
  }

  ${(p) => p.theme.media.mobileDown} {
    padding: 0;
  }
`;
